import { Input, InputGroup, InputLeftElement } from "@chakra-ui/react";
import JGoogleIcon from "../../JGoogleIcon/JGoogleIcon";
import { headingTheme } from "../../../theme/components";
import sidebarV2Store from "../../../stores/sidebar-v2.store";
import { useDebouncedCallback } from "use-debounce";
import useSidebarV2 from "../useSidebarV2";



export default function Searchbar() {
  const { search, setSearch, reveal } = sidebarV2Store()
  const { textColor, searchBarBackgroundColor } = useSidebarV2()

  const debouncedSearch = useDebouncedCallback(
    (value) => {
      setSearch(value)
    },
    1000
  );

  return (
    <InputGroup>
      <InputLeftElement>
        <JGoogleIcon
          name='search'
          fontSize='24px'
          color={textColor}
        />
      </InputLeftElement>
      <Input
        {...headingTheme.sizes.chakra_label_large}
        type='search'
        placeholder='Search Menu...'
        _placeholder={{ color: textColor }}
        backgroundColor={searchBarBackgroundColor}
        border='none'
        color={textColor}
        defaultValue={search}
        onChange={(e) => debouncedSearch(e.target.value)}
      />
    </InputGroup>
  )
}
